export function AppIcon({ app, size }) {
  const className = ['app-icon', size === 'large' ? 'large' : '', app.accent || '']
    .filter(Boolean)
    .join(' ');

  if (app.icon) {
    return (
      <img className={className} src={app.icon} alt={`${app.name} icon`} />
    );
  }

  return (
    <div className={className} aria-hidden="true">{app.name.charAt(0)}</div>
  );
}
